/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { getTheme } from "office-ui-fabric-react/lib/Styling";
import styled from "styled-components";

const theme = getTheme();
/**
 * Styled component that returns error message in red.
 */
// TODO: Holding off on font-size and color of error message until Kyle finalzes mockups for error messages
export const RedText = styled.p`
  color: ${theme.palette.red};
  font-size: 12px;
  margin-top: 2px;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

/**
 * Styled div for error message.
 */
export const ErrorMessageDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

/**
 * Styled div for red text.
 */
export const RedTextDiv = styled.div`
  height: 0;
`;
